export const DocumentationStateEnum = {
    PENDING: 1,
    UPLOADED: 2,
    APPROVED: 3,
  };
